import Portfolio from "../../componets/Portfolio";

export default function Section1() {
  return (
    <div className="Section1 h-[30vh] xl:h-[60vh]">
      <Portfolio
        bgImage={"assets/banner-image-social-media-marketing.jpg"}
        objectPosition={"object-center"}
        customer={false}
        altText="Social Media Marketing Background Image"
      />
    </div>
  );
}
